var render = function render(){var _vm=this,_c=_vm._self._c;return (this.isMobile)?_c('div',{staticClass:"wave-footer-bottom-img flex-end width-100p foreground"}):_c('div',{staticClass:"line-height-0"},[_c('div',{staticClass:"wave-footer-bottom-img pos-absolute pos-absolute-left-zero pos-absolute-bottom-zero"})])
}
var staticRenderFns = []

export { render, staticRenderFns }